module.exports = __webpack_public_path__ + "static/assets/a35ecb495a9e412b4b6c9de6f74f11e2.svg";